export enum statCd{
    S = 'Processed',
    R = 'Received',
    D = 'Deleted',
    I = 'Intialized',
    L = 'Loaded',
    F = 'Rejected',
    E = 'FTP Error'
}
